/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JudgesService {
    /**
     * List all judges
     * Get a paginated list of judges for the authenticated user
     * @param isActive Filter by active status
     * @param search Search by judge name
     * @returns any List of judges
     * @throws ApiError
     */
    public static be3F674Dae85168Df163Bf6Ccbfb(
        isActive?: 'Yes' | 'No',
        search?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/judges',
            query: {
                'is_active': isActive,
                'search': search,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new judge
     * Create a new judge
     * @param requestBody
     * @returns any Judge created successfully
     * @throws ApiError
     */
    public static b7933C4965F87A0Ea979E12(
        requestBody: {
            judge_name: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/judges',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific judge
     * Retrieve details of a specific judge
     * @param id Judge ID
     * @returns any Judge details
     * @throws ApiError
     */
    public static e70647F5049942839482383543A3304C(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/judges/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Judge not found`,
            },
        });
    }
    /**
     * Update a judge
     * Update an existing judge
     * @param id Judge ID
     * @param requestBody
     * @returns any Judge updated successfully
     * @throws ApiError
     */
    public static b041Bbd58791Bd33043Ae69C23B9Fa9F(
        id: number,
        requestBody: {
            judge_name?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/judges/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Judge not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a judge
     * Delete a judge
     * @param id Judge ID
     * @returns any Judge deleted successfully
     * @throws ApiError
     */
    public static a1D0A4C7Acc0B98C564A9C1E5E5A265F(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/judges/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Judge not found`,
            },
        });
    }
}
